import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import editpic from "../../assets/edit.svg";
import deletepic from "../../assets/delete.svg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import iicon from "../../assets/i.svg";
import { CategoriesList } from "./../API/MarketPlaceSetUp/CategoriesListing";
import Loader from "../Loader/Loader";
import swal from "sweetalert";
import { DeleteCategories } from "./../API/MarketPlaceSetUp/DeleteCategories";
import ModalPopUp from "./PopUpForMarketPlace/ModalPopUp";

import Modal from "react-bootstrap/Modal";
import List_items from "./PopUpForMarketPlace/ListItems";
import house from "../../assets/shortcut1.png";
import boxHand from "../../assets/category-box.png";
import Pagination from "../Pagination/Pagination";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { CheckListItem } from "../API/MarketPlaceSetUp/CheckListItem";
import { SaveShortcut } from "../API/MarketPlaceSetUp/SaveShortcut";
import { DeleteShortcutCategory } from "../API/MarketPlaceSetUp/DeleteShortcut";
import { ShortcutEdit } from "./../API/MarketPlaceSetUp/ShortcutCatgoriesEdit";
import { ShortcutList } from "./../API/MarketPlaceSetUp/ShortcutList";
import deletePopUp from "../../assets/deletePopUp.svg";
import NoDataText from "../NoDataText";

export const Categories = () => {
  const [loading, setLoading] = useState(false);
  const [TableRows, setTableRows] = useState([]);
  const [ShowTable, setShowTable] = useState(false);
  const [globalTableRows, setglobalTableRows] = useState([]);
  // checkbox
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  // shortcuts-list
  const [TableRowsShortcuts, setTableRowsShortcuts] = useState([]);
  const [ShowTableShortcuts, setShowTableShortcuts] = useState(false);
  const [globalTableRowsShortcuts, setglobalTableRowsShortcuts] = useState([]);
  // checkbox-shortcuts
  const [isCheckAllShortcuts, setIsCheckAllShortcuts] = useState(false);
  const [isCheckShortcuts, setIsCheckShortcuts] = useState([]);

  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);

  // shortcuts - pagination

  const [totalPageCount_sc, setTotalPageCount_sc] = useState(0);
  const [pageNumber_sc, setPageNumber_sc] = useState(0);
  const [limit_sc, setLimit_sc] = useState(0);

  // sort
  const [flag, setFlag] = useState({
    cat_name: 0,
    msc_name: 0,
  });

  // popup2/2
  const [listData, setListData] = useState([]);
  const [globallistData, setGloballistDataListData] = useState([]);
  const [isCheck_sc, setisCheck_sc] = useState([]);
  const [IsSelected_ScLengthErr, setIsSelected_ScLengthErr] = useState("");
  // pop-2/3
  const [shortcutName, setshortcutName] = useState("");

  // search
  const [search, setSearch] = useState("");

  // popup - 1/1
  const [show, setShow] = useState(false);

  // popup-2/1
  const [hide, setHide] = useState(false);
  // popup-2/2
  const [show2, setShow2] = useState(false);
  // popup-2/3
  const [show3, setShow3] = useState(false);

  const [shortcutNameErr, setshortcutNameErr] = useState(false);

  // delete popups
  const [deletePop, setdeletePop] = useState(false);
  const [Cat_id, setCat_id] = useState([]);

  // edit-shortcuts
  const [EditShow, setEditShow] = useState(false);
  const [shortcutNameEdit, setshortcutNameEdit] = useState("");
  const [shortcutIdEdit, setshortcutIdEdit] = useState(0);
  const [listDataEdit, setlistDataEdit] = useState([]);
  const [globallistDataEdit, setgloballistDataEdit] = useState([]);

  const [noDataScCheckbox, setnoDataScCheckbox] = useState(false);

  // add
  const [listDataAdd, setListDataAdd] = useState([]);
  const [globallistDataAdd, setGloballistDataListDataAdd] = useState([]);

  // bottom
  const EndRef = useRef(null);
  const scrollToBottom = () => {
    EndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    ApiLoadPopup2List();
    // ApiLoad()
  }, []);

  const ApiLoad = async () => {
    // console.log("first")
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      cat_offset: pageNumber,
      cat_limit: 5,
    };
    const coupondetailData = await CategoriesList(data, () => {
      navigate("/");
    });
    // console.log(coupondetailData, "coupondetailData");
    setLoading(false);
    if (coupondetailData.success === false) {
      setShowTable(true);
      setShowTableShortcuts(true);
    } else if (coupondetailData.staus === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "OK",
        dangerMode: false,
      });
    } else {
      if (coupondetailData.categorylist.categories.length == 0) {
        setShowTable(true);
      } else {
        setShowTable(false);
        setTableRows(coupondetailData.categorylist.categories);
        setglobalTableRows(coupondetailData.categorylist.categories);
        setTotalPageCount(coupondetailData.categorylist.total_cat_row);
        setLimit(coupondetailData.categorylist.limit);
      }

      if (coupondetailData.shortcutlist.shortcut_categories.length == 0) {
        setShowTableShortcuts(true);
      } else {
        setTableRowsShortcuts(
          coupondetailData.shortcutlist.shortcut_categories
        );
        setglobalTableRowsShortcuts(
          coupondetailData.shortcutlist.shortcut_categories
        );
        setTotalPageCount_sc(
          coupondetailData.shortcutlist.total_shortCut_Count
        );
        setLimit_sc(coupondetailData.shortcutlist.limit);
      }
    }
  };

  const ApiLoadPopup2List = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
    };
    const coupondetailData = await CheckListItem(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "Ok",
        dangerMode: false,
      });
    } else if (coupondetailData.success === false) {
      setLoading(false);
    } else {
      const others = coupondetailData.data.filter(
        (elem) => elem.status === true
      );
      const removedOthers = others.filter(
        (elem) => elem.cat_name != "OTHERS" || "others" || "Others"
      );
      setListData(removedOthers);
      setGloballistDataListData(removedOthers);
      setLoading(false);
    }
  };

  // search
  useEffect(() => {
    handleSearch();
  }, [search]);

  const handleSearch = () => {
    if (EditShow != true) {
      if (search.length === 0) {
        setListData(globallistData);
        setnoDataScCheckbox(false);
      } else {
        const filteredData = listData.filter((data) =>
          data.cat_name.toLowerCase().startsWith(search?.toLocaleLowerCase())
        );
        if (filteredData.length == 0) {
          setnoDataScCheckbox(true);
        } else {
          setnoDataScCheckbox(false);
          setListData(filteredData);
        }
      }
    } else {
      if (search.length === 0) {
        setlistDataEdit(globallistDataEdit);
        setnoDataScCheckbox(false);
      } else {
        const filteredData = listDataEdit.filter((data) =>
          data.cat_name.toLowerCase().startsWith(search?.toLocaleLowerCase())
        );
        if (filteredData.length == 0) {
          setnoDataScCheckbox(true);
        } else {
          setnoDataScCheckbox(false);
          setlistDataEdit(filteredData);
        }
      }
    }
  };
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };
  // pagination - categories
  const pageChange = async () => {
    // console.log("pagination")
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      cat_offset: pageNumber,
      cat_limit: 5,
    };
    const coupondetailData = await CategoriesList(data, () => {
      navigate("/");
    });
    if (coupondetailData.success === false) {
      setShowTable(true);
      setShowTableShortcuts(true);
    } else if (coupondetailData.staus === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "OK",
        dangerMode: false,
      });
    } else {
      if (coupondetailData.categorylist.categories.length == 0) {
        setShowTable(true);
      } else {
        setShowTable(false);
        setTableRows(coupondetailData.categorylist.categories);
        setglobalTableRows(coupondetailData.categorylist.categories);
        setTotalPageCount(coupondetailData.categorylist.total_cat_row);
        setLimit(coupondetailData.categorylist.limit);
        setLoading(false);
      }
    }
  };
  // - categories
  useEffect(() => {
    setLoading(true);
    pageChange();
  }, [pageNumber]);

  // pagination - categories
  const pageChange_sc = async () => {
    // console.log("pagination")
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      sc_offset: pageNumber_sc,
      sc_limit: 5,
    };
    const coupondetailData = await CategoriesList(data, () => {
      navigate("/");
    });
    if (coupondetailData.success === false) {
      setShowTable(true);
      setShowTableShortcuts(true);
    } else if (coupondetailData.staus === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "OK",
        dangerMode: false,
      });
    } else {
      if (coupondetailData.shortcutlist.shortcut_categories.length == 0) {
        setShowTableShortcuts(true);
      } else {
        setShowTableShortcuts(false);
        setTableRowsShortcuts(
          coupondetailData.shortcutlist.shortcut_categories
        );
        setglobalTableRowsShortcuts(
          coupondetailData.shortcutlist.shortcut_categories
        );
        setTotalPageCount_sc(
          coupondetailData.shortcutlist.total_shortCut_Count
        );
        setLimit_sc(coupondetailData.shortcutlist.limit);
        setLoading(false);
      }
    }
  };
  // - categories
  useEffect(() => {
    setLoading(true);
    pageChange_sc();
  }, [pageNumber_sc]);

  // checkbox - th
  const handleSelectAll = (e) => {
    const filteredIds = TableRows?.filter(
      (li) => li?.category_name?.toLocaleLowerCase() !== "others"
    ).map((li) => li.category_id);

    setIsCheckAll(!isCheckAll);
    setIsCheck(filteredIds);
    // console.log(
    //   TableRows.map((li) => {
    //     if (li.category_name?.toLocaleLowerCase() !== "others")
    //       return li.category_id;
    //   }),
    //   "idooo"
    // );
    if (isCheckAll) {
      setIsCheck([]);
    }
  };
  // checkbox - tr
  const handleClick = (e, key) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, TableRows[key].category_id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== TableRows[key].category_id));
    }
  };

  // checkboxShortcuts - th
  const handleSelectAllShortcut = (e) => {
    setIsCheckAllShortcuts(!isCheckAllShortcuts);
    setIsCheckShortcuts(TableRowsShortcuts.map((li) => li.marketplace_subCat));
    if (isCheckAllShortcuts) {
      setIsCheckShortcuts([]);
    }
  };

  // checkboxShortcuts - tr
  const handleClickShortcuts = (e, key) => {
    const { checked } = e.target;
    setIsCheckShortcuts([
      ...isCheckShortcuts,
      TableRowsShortcuts[key].marketplace_subCat,
    ]);
    if (!checked) {
      setIsCheckShortcuts(
        isCheckShortcuts.filter(
          (item) => item !== TableRowsShortcuts[key].marketplace_subCat
        )
      );
    }
  };

  // popup-checkbox_sc
  // checkbox - tr
  const handleClick_sc = (e, key, flag) => {
    const { checked } = e.target;
    if (EditShow == true) {
      if (listDataEdit[key].status == true) {
        // setisCheck_sc([...isCheck_sc,])
        setlistDataEdit((value) => {
          const newArr = value.slice();
          newArr[key].status = false;
          // console.log(newArr, "newArr");
          return newArr;
        });
      } else {
        setlistDataEdit((value) => {
          const newArr = value.slice();
          newArr[key].status = true;
          // console.log(newArr,"newArr")
          return newArr;
        });
      }

      setisCheck_sc([...isCheck_sc, listDataEdit[key].cat_id]);
      if (!checked) {
        setisCheck_sc(
          isCheck_sc.filter((item) => item !== listDataEdit[key].cat_id)
        );
      }
    } else {
      setisCheck_sc([...isCheck_sc, listData[key].cat_id]);
      if (!checked) {
        setisCheck_sc(
          isCheck_sc.filter((item) => item !== listData[key].cat_id)
        );
      }
    }
  };

  useEffect(() => {
    if (EditShow !== true) {
      if (isCheck_sc.length > 3) {
        swal({
          // title: "Error!",
          title: `You can select maximum 3 categories`,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        }).then(() => {
          setisCheck_sc([]);
        });
      }
    }
  }, [isCheck_sc]);

  // delete APi
  const handleDeleteEach = async () => {
    setLoading(true);
    setdeletePop(false);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      category_id: [Cat_id.category_id],
    };

    // const coupondetailData = await DeletePages(data);
    // console.log(coupondetailData,"coupondetailData")
    // setLoading(false);
    // swal({
    //   title: `Are you sure you want to delete ${Cat_id.category_name}?`,
    //   text: "Once deleted, you will not be able to recover!",
    //   icon: "error",
    //   buttons: true,
    //   dangerMode: false,
    // }).then(async (willDelete) => {
    // if (willDelete) {
    setLoading(true);
    const coupondetailData = await DeleteCategories(data, () => {
      navigate("/");
    });
    if (coupondetailData === false) {
      setLoading(false);
      swal({
        text: "Internal Server Error!",
        icon: "error",
        buttons: "Ok",
      });
    } else {
      if (coupondetailData.status === 429) {
        setLoading(true);
        swal({
          // title: "Error!",
          title: `${coupondetailData.message}`,
          icon: "error",
          buttons: "Ok",
        });
      } else if (coupondetailData.success === false) {
        setLoading(false);
        swal({
          // title: "Error!",
          title: `${coupondetailData.message}`,
          icon: "error",
          buttons: "Ok",
        });
      } else {
        setLoading(false);
        swal({
          // title: "Success!",
          title: `${Cat_id.category_name} has been deleted successfully!`,
          icon: "success",
          buttons: "Ok",
        });
        setIsCheck([]);
        setShowTable(false);
        // console.log(coupondetailData,"ftyftdrtdtdtdtdt")
        setTableRows(coupondetailData.categorylist.categories);
      }
    }
    // }
    // });
  };

  const handleDeleteEach1 = (e, key) => {
    setCat_id(TableRows[key]);
    setdeletePop(true);
  };

  // delete - chckbox
  const handleDelete = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      category_id: isCheck,
    };
    swal({
      title: `Are you sure you want to delete selected categories?`,
      text: "If you delete this category all the business listings under this category will move to “Others”",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        const coupondetailData = await DeleteCategories(data, () => {
          navigate("/");
        });
        if (coupondetailData === false) {
          setLoading(false);
          swal({
            text: "Internal Server Error!",
            icon: "error",
            buttons: "Ok",
          });
        } else {
          if (coupondetailData.status === 429) {
            setLoading(true);
            swal({
              // title: "Error!",
              title: `${coupondetailData.message}`,
              icon: "error",
              buttons: "Ok",
            });
          } else if (coupondetailData.success === true) {
            setLoading(false);
            swal({
              // title: "Success!",
              title: `selected categories has been deleted successfully!`,
              icon: "success",
              buttons: "Ok",
            });
            setIsCheck([]);
            setShowTable(false);
            setTableRows(coupondetailData.categorylist.categories);
            setIsCheckAll(false);
          } else {
            setLoading(false);
            swal({
              text: coupondetailData.message,
              icon: "error",
              buttons: "Ok",
            });
          }
        }
      }
    });
    setLoading(false);
  };

  const HandleSortCol = (value) => {
    // cat_sort_type: 0,
    if (value == "cat_name") {
      if (flag.cat_name === 0) {
        handleSort(1, "cat_name");
        setFlag((item) => {
          return { ...item, cat_name: 1 };
        });
      } else if (flag.cat_name === 1) {
        handleSort(2, "cat_name");
        setFlag((item) => {
          return { ...item, cat_name: 2 };
        });
      } else {
        handleSort(0, "cat_name");
        setFlag((item) => {
          return { ...item, cat_name: 0 };
        });
      }
    }

    // shortcut-categories: 0,
    if (value == "msc_name") {
      if (flag.msc_name === 0) {
        handleSort(1, "msc_name");
        setFlag((item) => {
          return { ...item, msc_name: 1 };
        });
      } else if (flag.msc_name === 1) {
        handleSort(2, "msc_name");
        setFlag((item) => {
          return { ...item, msc_name: 2 };
        });
      } else {
        handleSort(0, "msc_name");
        setFlag((item) => {
          return { ...item, msc_name: 0 };
        });
      }
    }
  };

  // sort
  // Api for sort
  const handleSort = async (sortNo, colValue) => {
    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      cat_limit: 5,
      cat_offset: pageNumber,
      cat_column_name: colValue,
      cat_sort_type: sortNo,
    };

    const data_sc = {
      mms_city_id: parseInt(cityId),
      sc_limit: 5,
      sc_offset: pageNumber_sc,
      sc_column_name: colValue,
      sc_sort_type: sortNo,
    };
    const coupondetailData = await CategoriesList(
      colValue == "cat_name" ? data : data_sc,
      () => {
        navigate("/");
      }
    );
    setLoading(false);
    if (coupondetailData.staus === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "OK",
        dangerMode: false,
      });
    } else if (coupondetailData.message === "No Data Available") {
      setShowTable(true);
      setLoading(false);
    } else {
      setLoading(false);
      setShowTable(false);
      if (colValue == "cat_name") {
        setTableRows(coupondetailData.categorylist.categories);
        setglobalTableRows(coupondetailData.categorylist.categories);
        setTotalPageCount(coupondetailData.categorylist.total_cat_row);
        setLimit(coupondetailData.categorylist.limit);
      } else {
        setTableRowsShortcuts(
          coupondetailData.shortcutlist.shortcut_categories
        );
        setglobalTableRowsShortcuts(
          coupondetailData.shortcutlist.shortcut_categories
        );
        setTotalPageCount_sc(
          coupondetailData.shortcutlist.total_shortCut_Count
        );
        setLimit_sc(coupondetailData.shortcutlist.limit);
      }
    }
  };

  // popup2-1
  const hanldepopup1 = () => {
    setHide(false);
    setShow2(true);
    setIsSelected_ScLengthErr("");
  };

  // popup2-2
  const hanldepopup2 = () => {
    if (isCheck_sc.length == 0) {
      setIsSelected_ScLengthErr("Please select maximum 3 shortcut categories!");
    } else if (isCheck_sc.length <= 1) {
      setIsSelected_ScLengthErr(
        "Please select more than 1 shortcut categories!"
      );
    } else if (isCheck_sc.length > 3) {
      setIsSelected_ScLengthErr("Please select maximum 3 shortcut categories!");
    } else {
      setHide(false);
      setShow2(false);
      setShow3(true);
    }

    if (EditShow === true) {
      setshortcutName(shortcutNameEdit);
    } else {
      setshortcutName("");
    }
  };

  // popup2-3
  const hanldepopup3 = async () => {
    setIsSelected_ScLengthErr("");
    if (shortcutName.length == 0) {
      setshortcutNameErr(true);
      setHide(false);
      setShow2(false);
      setShow3(true);
    } else {
      setHide(false);
      setShow2(false);
      setShow3(false);
      setshortcutName("");

      const cityId = localStorage.getItem("cityId");
      const data = {
        mms_city_id: parseInt(cityId),
        category_ids: isCheck_sc,
        sub_cat_name: shortcutName,
      };
      const coupondetailData = await SaveShortcut(data, () => {
        navigate("/");
      });
      setLoading(false);
      // console.log(coupondetailData, "1234");
      setisCheck_sc([]);
      if (coupondetailData.status === true) {
        setLoading(true);
        swal({
          // title: "Error!",
          title: ` ${coupondetailData.message}`,
          icon: "error",
          buttons: "Ok",
        });
      } else if (coupondetailData.success === false) {
        setLoading(false);
        swal({
          // title: "Error!",
          title: ` ${coupondetailData.message}`,
          icon: "error",
          buttons: "Ok",
        });
      } else {
        swal({
          // title: "Success!",
          title: `${coupondetailData.message}`,
          icon: "success",
          buttons: "Ok",
        }).then((success) => {
          if (success) {
            window.location.reload(false);
          }
        });
        // setTableRowsShortcuts(
        //   coupondetailData.shortcutlist.shortcut_categories
        // );
        // setglobalTableRowsShortcuts(
        //   coupondetailData.shortcutlist.shortcut_categories
        // );
        // setTotalPageCount_sc(
        //   coupondetailData.shortcutlist.total_shortCut_Count
        // );
        // setLimit_sc(coupondetailData.shortcutlist.limit);
        setLoading(false);
      }
    }
  };

  // shortcut- delete-each
  const hanldeDeleteShortcut = async (e, key) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      shortcut_Id: [TableRowsShortcuts[key].marketplace_subCat],
    };
    swal({
      title: `Are you sure you want to delete ${TableRowsShortcuts[key].sub_cat_name}?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        const coupondetailData = await DeleteShortcutCategory(data, () => {
          navigate("/");
        });
        if (coupondetailData.success == true) {
          swal({
            // title: "Success!",
            title: ` ${TableRowsShortcuts[key].sub_cat_name} has been deleted successfully!`,
            icon: "success",
            buttons: "Ok",
          });
          setIsCheck([]);
          setLoading(false);
          setShowTable(false);
          setTableRowsShortcuts(
            coupondetailData.shortcutlist.shortcut_categories
          );
          setglobalTableRowsShortcuts(
            coupondetailData.shortcutlist.shortcut_categories
          );
          setTotalPageCount_sc(
            coupondetailData.shortcutlist.total_shortCut_Count
          );
          setLimit_sc(coupondetailData.shortcutlist.limit);
        } else if (coupondetailData.status === 429) {
          swal({
            // title: "Error!",
            title: ` ${coupondetailData.message}`,
            icon: "error",
            buttons: "Ok",
          });
          setLoading(true);
        } else {
          swal({
            // title: "Error!",
            title: ` ${coupondetailData.message}`,
            icon: "error",
            buttons: "Ok",
          });
        }
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  // shortcut-delete-multiple

  const hanldeDeleteShortcutAll = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      shortcut_Id: isCheckShortcuts,
    };
    swal({
      title: `Are you sure you want to delete selected shortcut categories?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        const coupondetailData = await DeleteShortcutCategory(data, () => {
          navigate("/");
        });
        if (coupondetailData.success == true) {
          swal({
            // title: "Success!",
            title: `Selected shortcut categories has been deleted successfully!`,
            icon: "success",
            buttons: "Ok",
          });
          setIsCheckShortcuts([]);
          setLoading(false);
          setShowTable(false);
          if (coupondetailData.shortcutlist.shortcut_categories.length == 0) {
            setShowTableShortcuts(true);
          } else {
            setTableRowsShortcuts(
              coupondetailData.shortcutlist.shortcut_categories
            );
            setglobalTableRowsShortcuts(
              coupondetailData.shortcutlist.shortcut_categories
            );
            setTotalPageCount_sc(
              coupondetailData.shortcutlist.total_shortCut_Count
            );
            setLimit_sc(coupondetailData.shortcutlist.limit);
          }
        } else if (coupondetailData.status === 429) {
          swal({
            // title: "Error!",
            title: ` ${coupondetailData.message}`,
            icon: "error",
            buttons: "Ok",
          });
          setLoading(true);
        } else {
          swal({
            // title: "Error!",
            title: ` ${coupondetailData.message}`,
            icon: "error",
            buttons: "Ok",
          });
        }
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
    setLoading(false);
  };

  // edit
  const hanldeEditShortcut = async (e, key) => {
    // console.log(TableRowsShortcuts[key]);
    setEditShow(true);
    setHide(true);
    setshortcutNameEdit(TableRowsShortcuts[key].sub_cat_name);
    setshortcutIdEdit(TableRowsShortcuts[key].marketplace_subCat);

    // api
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      shortcut_id: TableRowsShortcuts[key].marketplace_subCat,
    };

    EditShortcutCatAPI(data);
  };

  const EditShortcutCatAPI = async (data) => {
    const Response = await ShortcutList(data, () => {
      navigate("/");
    });
    if (Response.status === 429) {
      setLoading(true);
      swal({
        // title: "Error!",
        title: `${Response.message}`,
        icon: "error",
        buttons: "OK",
      });
    } else if (Response.success === false) {
      swal({
        // title: "Error!",
        title: ` ${Response.message}`,
        icon: "error",
        buttons: "Ok",
      });
    } else {
      setlistDataEdit(Response.data);
      setgloballistDataEdit(Response.data);
      const initalCheck_sc = Response.data.filter((i, k) => i.status == true);
      const preFilledCat_id = [];
      initalCheck_sc.map((i, k) => preFilledCat_id.push(i.cat_id));
      setisCheck_sc(preFilledCat_id);
    }
  };

  const handleEditSave = async () => {
    setEditShow(false);
    if (shortcutName.length == 0) {
      setshortcutNameErr(true);
      setHide(false);
      setShow2(false);
      setShow3(true);
    } else {
      setHide(false);
      setShow2(false);
      setShow3(false);
      setshortcutName("");

      const cityId = localStorage.getItem("cityId");
      const data = {
        mms_city_id: parseInt(cityId),
        sub_cat_name: shortcutName,
        category_ids: isCheck_sc,
        shortcut_Id: shortcutIdEdit,
      };
      const Response = await ShortcutEdit(data, () => {
        navigate("/");
      });
      setLoading(false);
      // console.log(coupondetailData, "1234");
      setisCheck_sc([]);
      if (Response.status === true) {
        setLoading(true);
        swal({
          // title: "Error!",
          title: ` ${Response.message}`,
          icon: "error",
          buttons: "Ok",
        });
      }
      if (Response.success === false) {
        setLoading(false);
        swal({
          // title: "Error!",
          title: ` ${Response.message}`,
          icon: "error",
          buttons: "Ok",
        });
      } else {
        swal({
          // title: "Success!",
          title: `${Response.message}`,
          icon: "success",
          buttons: "Ok",
        }).then((success) => {
          if (success) {
            window.location.reload(false);
          }
        });
        setLoading(false);
      }
    }
  };

  // Api for add category list
  const AddCategoryAPI = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
    };
    const coupondetailData = await CheckListItem(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "Ok",
        dangerMode: false,
      });
    }
    //  console.log(coupondetailData,"coupondetailData")
    else if (coupondetailData.success === false) {
      // setLoading(false);
    } else {
      setListDataAdd(coupondetailData.data);
      setGloballistDataListDataAdd(coupondetailData.data);
      //setLoading(false);
    }
  };
  return (
    <>
      {loading ? <Loader /> : ""}
      {/* popup for category delete */}
      <Modal
        show={deletePop}
        onHide={() => setdeletePop(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="popup-modal"
      >
        {/* <Modal.Header closeButton></Modal.Header>{" "} */}
        <Modal.Body className="text-center mb-5">
          <div className="shortcut1">
            <img className="shortcut-image-one" src={deletePopUp} />
            <p className="select-three deletePop">
              If you delete this category all the business listings under this
              category will move to “Others”
            </p>
          </div>
          <div className="text-center small-btns d-flex option_btn cancel">
            <button
              type="button"
              class="discard_btn btn btn-primary"
              onClick={() => {
                setdeletePop(false);
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              class="green-btn mt-3 btn btn-primary"
              onClick={handleDeleteEach}
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* add-category - popup-1/1 */}
      <Modal
        show={hide}
        onHide={() => setHide(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="popup-modal"
      >
        {/* <Modal.Header closeButton></Modal.Header>{" "} */}
        <Modal.Body className="text-center mb-5">
          <div className="shortcut1">
            <p className="create-shortcut">Create Shortcut Categories</p>
            <img className="shortcut-image-one" src={house} />
            <p className="select-three">
              You can select up to 3 categories to make one group category
            </p>
          </div>
          <div className="text-center small-btns d-flex option_btn cancel">
            <button
              type="button"
              class="discard_btn btn btn-primary"
              onClick={() => {
                setHide(false);
                setisCheck_sc([]);
                setEditShow(false);
              }}
            >
              Back
            </button>
            <button
              type="submit"
              class="green-btn mt-3 btn btn-primary"
              onClick={hanldepopup1}
            >
              Next
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <ModalPopUp
        show={show}
        setShow={setShow}
        loading={loading}
        setTableRows={setTableRows}
        setglobalTableRows={setglobalTableRows}
        setTotalPageCount={setTotalPageCount}
        setLimit={setLimit}
        setLoading={setLoading}
        setListDataAdd={setListDataAdd}
        listDataAdd={listDataAdd}
        setGloballistDataListDataAdd={setGloballistDataListDataAdd}
        globallistDataAdd={globallistDataAdd}
        EndRef={EndRef}
        scrollToBottom={scrollToBottom}
      />

      <div className="manage-vou-main pt-3 pb-3">
        <div className="d-flex">
          <p className="page-maintitle pt-1">Categories</p>
          <div>
            {["top"].map((placement) => (
              <OverlayTrigger
                key={placement}
                placement={placement}
                overlay={
                  <Tooltip
                    id={`tooltip-${placement}`}
                    className="Tooltips"
                    style={{ opacity: "1" }}
                  >
                    Add custom categories or select from the list below. The
                    list is visible to all businesses in your marketplace.
                  </Tooltip>
                }
              >
                <Image src={iicon} className="pt-1" width="20px"></Image>
              </OverlayTrigger>
            ))}
          </div>
        </div>
        <div className="manage-vou">
          <Button
            variant="primary"
            className="create-btn export-btn-main"
            onClick={() => {
              setShow(true);
              AddCategoryAPI();
            }}
          >
            + Add Category
          </Button>
        </div>
      </div>
      {isCheck.length != 0 ? (
        <div className="d-flex">
          <Button
            className="green-btn width-150 p-0 mr-3 del_btn"
            onClick={handleDelete}
          >
            Delete Selected
          </Button>
          <Form.Select
            aria-label="Default select example"
            className="table-select width-150 ml-3 status_select"
            style={{ display: "none" }}
          >
            <option>Select Status</option>
            <option value="1">New</option>
            <option value="2">In Review</option>
            <option value="3">Published</option>
            <option value="4">Declined</option>
          </Form.Select>
        </div>
      ) : (
        ""
      )}

      <div class="table-responsive-xl black-header">
        <table class="recentact-table mt-3 table ver-middle manage-vou-table category-table">
          <thead>
            <tr>
              <th className="radio-colors">
                <Form.Check
                  aria-label="option 1"
                  className="orange-checkbox"
                  onChange={handleSelectAll}
                  checked={isCheckAll}
                />
              </th>
              <th
                onClick={() => HandleSortCol("cat_name")}
                style={{ textAlign: "left" }}
              >
                Categories
                {flag.cat_name === 0 ? (
                  <FaSort></FaSort>
                ) : flag.cat_name === 1 ? (
                  <FaSortUp></FaSortUp>
                ) : (
                  <FaSortDown></FaSortDown>
                )}
              </th>
              <th style={{ textAlign: "center" }}>
                <span style={{ fontWeight: "bold" }}>#Marketplace</span>
                <br />
                <span style={{ fontWeight: "bold" }}>Category</span>
              </th>
              <th style={{ textAlign: "center" }}>
                <span style={{ fontWeight: "bold" }}>#Business Listings</span>
                <br />
                <span style={{ fontWeight: "bold" }}>Category</span>
              </th>

              <th className="action-min-main" style={{ textAlign: "center" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {ShowTable == false ? (
              <>
                {TableRows?.map((item, key) => {
                  return (
                    <tr>
                      <td className="radio-colors">
                        {item.category_name?.toLowerCase() != "others" ? (
                          <Form.Check
                            aria-label="option 1"
                            className="orange-checkbox"
                            onChange={(e) => handleClick(e, key)}
                            checked={isCheck.includes(item.category_id)}
                          />
                        ) : (
                          ""
                        )}
                      </td>
                      <td
                        style={{
                          textAlign: "left",
                          color:
                            item.custom_status == true ? "#e66100" : "black",
                        }}
                      >
                        {item.category_name}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          color:
                            item.custom_status == true ? "#e66100" : "black",
                        }}
                      >
                        {item.mms_assigned_business_count}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          color:
                            item.custom_status == true ? "#e66100" : "black",
                        }}
                      >
                        {item.business_count}
                      </td>
                      <td>
                        <div
                          className="action-min-img"
                          style={{ justifyContent: "center" }}
                        >
                          {item.category_name?.toLowerCase() != "others" ? (
                            <Link>
                              <Image
                                src={deletepic}
                                onClick={(e) => handleDeleteEach1(e, key)}
                                title="Delete"
                              ></Image>
                            </Link>
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <tr class="toggle-row">
                <td colspan="8">
                  <p class="noData">{NoDataText.ErrText}</p>{" "}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {totalPageCount > 5 ? (
        <Pagination
          totalPageCount={totalPageCount}
          setPageNumber={setPageNumber}
          limit={limit}
        />
      ) : (
        <></>
      )}
      <div className="manage-vou-main pt-5 pb-3">
        <div className="d-flex">
          <p className="page-maintitle pt-1">Shortcut Categories </p>
          <div>
            {["top"].map((placement) => (
              <OverlayTrigger
                key={placement}
                placement={placement}
                overlay={
                  <Tooltip
                    id={`tooltip-${placement}`}
                    className="Tooltips"
                    style={{ opacity: "1" }}
                  >
                    Combine up to 3 categories to create a Shortcut Category,
                    which appears as a submenu alongside 'New Listings' and 'All
                    Listings'. A maximum of 5 Shortcut Categories can be
                    displayed.
                  </Tooltip>
                }
              >
                <Image src={iicon} className="pt-1" width="20px"></Image>
              </OverlayTrigger>
            ))}
          </div>
        </div>
        <div className="manage-vou">
          <Button
            variant="primary"
            className="create-btn export-btn-main"
            onClick={() => {
              if (TableRowsShortcuts.length < 5) {
                setHide(true);
              } else {
                swal({
                  text: "Markatplace can create maximum 5 shortcuts.",
                  icon: "error",
                  buttons: "Ok",
                });
              }
            }}
          >
            + Create Shortcut Category
          </Button>
        </div>

        {/* create-shortcut-category - popup-1/1 */}
        {/* popup-1/3 */}
        <Modal
          show={hide}
          onHide={() => setHide(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="popup-modal"
        >
          {/* <Modal.Header closeButton></Modal.Header>{" "} */}
          <Modal.Body className="text-center mb-5">
            <div className="shortcut1">
              <p className="create-shortcut">Create Shortcut Categories</p>
              <img className="shortcut-image-one" src={house} />
              <p className="select-three">
                You can select up to 3 categories to make one group category
              </p>
            </div>
            <div className="text-center small-btns d-flex option_btn cancel">
              <button
                type="button"
                class="discard_btn btn btn-primary"
                onClick={() => {
                  setHide(false);
                  setisCheck_sc([]);
                  setEditShow(false);
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                class="green-btn mt-3 btn btn-primary"
                onClick={hanldepopup1}
              >
                Next
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup-2/2 */}
        <Modal
          show={show2}
          onHide={() => setShow2(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="popup-modal"
        >
          {/* <Modal.Header closeButton></Modal.Header>{" "} */}
          <Modal.Body className="text-center mb-5">
            <div className="shortcut2">
              <div className="shortcut-2-head">
                <p>You can select maximum 3 categories</p>
                <div
                  className="search-bar input-group shortcut"
                  id="shortcut-search"
                >
                  <span className="input-group-text">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                    </svg>
                  </span>
                  <input
                    autoComplete="off"
                    className="form-control search_feild"
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                    onKeyPress={handleKeypress}
                  />
                  {/* <button
                    type="button"
                    class="btn btn-outline-secondary"
                    onClick={handleSearch}
                  >
                    Search
                  </button> */}
                </div>
              </div>
              <div>
                {/* <List_items /> */}

                {EditShow == true ? (
                  <div className="main-list">
                    {noDataScCheckbox != true ? (
                      <table>
                        {listDataEdit.length != 0 ? (
                          <>
                            {listDataEdit.map((item, key) => {
                              return (
                                <>
                                  <tr>
                                    <td radio-colors>
                                      <div
                                        class="orange-checkbox"
                                        style={{ marginRight: "10px" }}
                                      >
                                        <input
                                          aria-label="option 1"
                                          type="checkbox"
                                          class="form-check-input"
                                          checked={
                                            item.status === true
                                              ? true
                                              : isCheck_sc.includes(item.cat_id)
                                          }
                                          onChange={(e) =>
                                            handleClick_sc(e, key, "Edit")
                                          }
                                          // disabled={isDisable_sc ? true : false}
                                        ></input>
                                      </div>
                                    </td>
                                    <td className="pop-up-head">
                                      {item.cat_name}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <p class="noData">{NoDataText.ErrText}</p>
                        )}
                      </table>
                    ) : (
                      <p class="noData">{NoDataText.ErrText}</p>
                    )}
                  </div>
                ) : (
                  <div className="main-list">
                    {noDataScCheckbox != true ? (
                      <table>
                        {listData.length != 0 ? (
                          <>
                            {listData.map((item, key) => {
                              return (
                                <>
                                  <tr>
                                    <td radio-colors>
                                      <div
                                        class="orange-checkbox"
                                        style={{ marginRight: "10px" }}
                                      >
                                        <input
                                          aria-label="option 1"
                                          type="checkbox"
                                          class="form-check-input"
                                          checked={isCheck_sc.includes(
                                            item.cat_id
                                          )}
                                          onChange={(e) =>
                                            handleClick_sc(e, key, "Add")
                                          }
                                          // disabled={isDisable_sc ? true : false}
                                        ></input>
                                      </div>
                                    </td>
                                    <td className="pop-up-head">
                                      {item.cat_name}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <p class="noData">{NoDataText.ErrText}</p>
                        )}
                      </table>
                    ) : (
                      <p class="noData">{NoDataText.ErrText}</p>
                    )}
                  </div>
                )}
              </div>

              {IsSelected_ScLengthErr && (
                <p className="ErrorText">{IsSelected_ScLengthErr}</p>
              )}
              <div className="text-center small-btns d-flex option_btn cancel">
                <button
                  type="button"
                  class="discard_btn btn btn-primary"
                  onClick={() => {
                    setShow2(false);
                    // setisCheck_sc([]);
                    // setEditShow(false);
                    setHide(true);
                    setIsSelected_ScLengthErr("");
                  }}
                >
                  Back
                </button>
                <button
                  type="submit"
                  class="green-btn mt-3 btn btn-primary"
                  onClick={hanldepopup2}
                >
                  Next
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup-3/3 */}
        <Modal
          show={show3}
          onHide={() => setShow3(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="popup-modal"
        >
          {/* <Modal.Header closeButton></Modal.Header>{" "} */}
          <Modal.Body className="text-center mb-5">
            <div className="shortcut3">
              <img className="boxhand" src={boxHand} alt="hand" />
              <p>Give a name for your shortcut category</p>
              <input
                autoComplete="off"
                placeholder="Give a name"
                type="text"
                value={shortcutName}
                onChange={(e) => setshortcutName(e.target.value)}
                maxLength={15}
              ></input>
              <p className="max-char"> (Maximum characters allowed: 15) </p>
            </div>
            {shortcutNameErr && (
              <p className="ErrorText" style={{ padding: "0px 0px 0px 160px" }}>
                Please give a name for your shortcut category!
              </p>
            )}
            <div className="text-center small-btns d-flex option_btn cancel">
              <button
                type="button"
                class="discard_btn btn btn-primary"
                onClick={() => {
                  setShow3(false);
                  // setisCheck_sc([]);
                  // setEditShow(false);
                  setshortcutNameErr(false);
                  setShow2(true);
                  setIsSelected_ScLengthErr("");
                }}
              >
                Back
              </button>
              <button
                type="submit"
                class="green-btn mt-3 btn btn-primary"
                onClick={EditShow ? handleEditSave : hanldepopup3}
              >
                Save
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* end */}
      </div>
      {isCheckShortcuts.length != 0 ? (
        <div className="d-flex">
          <Button
            className="green-btn width-150 p-0 mr-3 del_btn"
            onClick={hanldeDeleteShortcutAll}
          >
            Delete Selected
          </Button>
          <Form.Select
            aria-label="Default select example"
            className="table-select width-150 ml-3 status_select"
            style={{ display: "none" }}
          >
            <option>Select Status</option>
            <option value="1">New</option>
            <option value="2">In Review</option>
            <option value="3">Published</option>
            <option value="4">Declined</option>
          </Form.Select>
        </div>
      ) : (
        ""
      )}

      <div class="table-responsive-xl black-header">
        <table class="recentact-table mt-3 table ver-middle manage-vou-table">
          <thead>
            <tr>
              <th className="radio-colors">
                <Form.Check
                  aria-label="option 1"
                  className="orange-checkbox"
                  onChange={handleSelectAllShortcut}
                  checked={isCheckAllShortcuts}
                />
              </th>
              <th
                onClick={() => HandleSortCol("msc_name")}
                style={{ textAlign: "left" }}
              >
                Shortcut Name
                {flag.msc_name === 0 ? (
                  <FaSort></FaSort>
                ) : flag.msc_name === 1 ? (
                  <FaSortUp></FaSortUp>
                ) : (
                  <FaSortDown></FaSortDown>
                )}
              </th>
              <th style={{ textAlign: "left" }}>Categories</th>
              <th className="action-min-main">Actions</th>
            </tr>
          </thead>
          <tbody>
            {ShowTableShortcuts === false ? (
              <>
                {TableRowsShortcuts?.map((itemS, key) => {
                  return (
                    <tr>
                      <td className="radio-colors">
                        <Form.Check
                          aria-label="option 1"
                          className="orange-checkbox"
                          onChange={(e) => handleClickShortcuts(e, key)}
                          checked={isCheckShortcuts.includes(
                            itemS.marketplace_subCat
                          )}
                        />
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {itemS.sub_cat_name}{" "}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {itemS.category.map((i, k) => {
                          return (
                            <span>
                              {i.categoey_name}
                              {k === itemS.category.length - 1 ? (
                                <></>
                              ) : (
                                <>, </>
                              )}
                            </span>
                          );
                        })}
                      </td>

                      <td>
                        <div className="action-min-img">
                          <Link>
                            <Image
                              src={editpic}
                              onClick={(e) => hanldeEditShortcut(e, key)}
                              title="Edit"
                            ></Image>
                          </Link>
                          <Link>
                            <Image
                              src={deletepic}
                              onClick={(e) => hanldeDeleteShortcut(e, key)}
                              title="Delete"
                            ></Image>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <>
                <tr class="toggle-row">
                  <td colspan="8">
                    <p class="noData">{NoDataText.ErrText}</p>{" "}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
      {totalPageCount_sc > 5 ? (
        <Pagination
          totalPageCount={totalPageCount_sc}
          setPageNumber={setPageNumber_sc}
          limit={limit_sc}
        />
      ) : (
        <></>
      )}
      <div ref={EndRef} />
    </>
  );
};
